
// import React from "react";
// import { Drawer, IconButton, Box } from "@mui/material";
// import { Close } from "@mui/icons-material";

// const Notification = ({ open, onClose }) => {
//   return (
//     <Drawer anchor="right" open={open} onClose={onClose}>
//       <Box sx={{ width: 300, p: 2 }}>
//         <IconButton onClick={onClose} sx={{ float: "right" }}>
//           <Close />
//         </IconButton>
//         <h3>Notifications</h3>
//         <p>Your notifications will appear here.</p>
//       </Box>
//     </Drawer>
//   );
// };

// export default Notification;


import React from "react";
import { Drawer, IconButton, Box, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText } from "@mui/material";
import { Close } from "@mui/icons-material";

const notifications = [
  {
    id: 1,
    title: "New Message",
    content: "You have received a new message.",
    image: "https://via.placeholder.com/50", // Replace with actual image URL
  },
  {
    id: 2,
    title: "Report Ready",
    content: "Your report is now available for download.",
    image: "https://via.placeholder.com/50",
  },
  {
    id: 3,
    title: "Server Maintenance",
    content: "Scheduled maintenance will occur at midnight.",
    image: "https://via.placeholder.com/50",
  },
  {
    id: 4,
    title: "New Friend Request",
    content: "John Doe has sent you a friend request.",
    image: "https://via.placeholder.com/50",
  },
  {
    id: 5,
    title: "Event Reminder",
    content: "Don't forget about your upcoming meeting at 3 PM.",
    image: "https://via.placeholder.com/50",
  },
];

const Notification = ({ open, onClose }) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 300, p: 2 }}>
        <IconButton onClick={onClose} sx={{ float: "right" }}>
          <Close />
        </IconButton>
        <Typography variant="h6" sx={{ mb: 2 }}>Notifications</Typography>
        <List>
          {notifications.map((notification) => (
            <ListItem key={notification.id} alignItems="flex-start">
              <ListItemAvatar>
                <Avatar src={notification.image} alt={notification.title} />
              </ListItemAvatar>
              <ListItemText
                primary={notification.title}
                secondary={notification.content}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default Notification;
